// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2ltGvPkpvqbBjW15_Dzkt6 {\n  margin-right: var(--space-small);\n}\n\n._2ltGvPkpvqbBjW15_Dzkt6:last-child {\n  margin-right: 0;\n}\n\n.AiXPFMWUBbCB8WgC1NHLy:link,\n.AiXPFMWUBbCB8WgC1NHLy:visited,\n.AiXPFMWUBbCB8WgC1NHLy:hover,\n.AiXPFMWUBbCB8WgC1NHLy:active {\n  display: inline-block;\n  color: var(--body-color);\n  border-bottom: 0;\n}\n\n.O2cqKEYaajSl9tG76Duna {\n  font-size: var(--striking-font-size);\n}\n", ""]);
// Exports
exports.locals = {
	"li": "_2ltGvPkpvqbBjW15_Dzkt6",
	"a": "AiXPFMWUBbCB8WgC1NHLy",
	"icon": "O2cqKEYaajSl9tG76Duna"
};
module.exports = exports;
